import React, {useState} from "react";

// ICONS
import * as FaIcons from "react-icons/fa"; //Now i get access to all the icons
import * as AiIcons from "react-icons/ai";
import {CiDark} from "react-icons/ci";

import {IconContext} from "react-icons";

// ROUTING

import {Link} from "react-router-dom";

// DATA FILE
import {SidebarData} from "./navbar_data";

// STYLES
import "./navbar.css";
// import Language from "../language";
import {useTranslation} from "react-i18next";
import BASIC_INFORMATION from '../../../data/basic_data';
import Language from "../../lang/language";
import {FaInstagram, FaLinkedin} from "react-icons/fa";

export default function Navbar() {

    const {t, i18n} = useTranslation();

    const [sidebar, setSidebar] = useState(false);

    const showSidebar = () => setSidebar(!sidebar);

    return (
        <>
            <IconContext.Provider value={{color: "#ffffff"}}>

                <div className="navbar1 fixed-top_bg-white d-flex align-items-center p-4 justify-content-between">
                    <div className="d-flex">
                        {/*<Link to="#" onClick={showSidebar}>*/}
                        {/*    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"*/}
                        {/*         className="bi bi-justify-left color-main- text-dark" viewBox="0 0 16 16">*/}
                        {/*        <path fill-rule="evenodd"*/}
                        {/*              d="M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>*/}
                        {/*    </svg>*/}
                        {/*</Link>*/}
                        <Link to="/" className="">
                            <h3 className={'text-dark'}>Boulevard</h3>
                        </Link>
                    </div>

                    <Link to="/" className="menu-bars_ text-start col-78">

                        {/*<img src="/assets/logo/ai.png" height="55"  alt="logo-from-ai"/>*/}

                        <h5 className={'text-dark'}>
                            {/*Software Development*/}
                            {/*Bulvar*/}
                        </h5>
                        {/*<small className="text-dark lead d-noned-md-block">🇺🇦️ Software Development</small>*/}
                    </Link>
                    {/*<div className="col-md-4">*/}
                    {/*<a href="/" className={'d-none d-md-block'}>*/}
                    {/*    <h2 className={'m-1 color-main'}>*/}
                    {/*        Growth  <img src="/assets/lang/images/ua.png" alt="Ukraine" width="20"/> Ukraine*/}
                    {/*    </h2>*/}
                    {/*</a>*/}
                    {/*<small className={'text-secondary'}>We work with ❤️ in 🇺🇦 for everyone.</small>*/}
                    {/*</div>*/}
                    <div className="d-flex align-items-center">

                        {/*<a href="/company" className={'m-1 nav-link'}>Company</a>*/}
                        {/*<a href="/#products" className={'m-2 nav-link'}>Products</a>*/}
                        {/*<a href="/services" className={'m-2 nav-link d-none d-md-block'}>Services</a>*/}
                        {/*<a href="/portfolio" className={'m-2 nav-link'}>Portfolio</a>*/}
                        {/*<a href="/company" className={'m-1 nav-link d-none d-md-block'}>Company</a>*/}
                        {/*<a href="/contacts" className={'m-2 nav-link d-none d-md-block'}>Contacts</a>*/}

                        <Link to="https://t.me/blvdltd" id={'btn-contact-us'}
                              className={'btn1 bg-dark rounded-5 p-3 pt-2 pb-2 align-items-center text-white'}>
                            {/*{t('nav.contact-us')}*/}
                            ENQUIRE
                        </Link>

                        {/*<CiDark color={'dark'} className={'m-1'} />*/}

                        {/*<Language color={'text-white'}/>*/}

                        {/*{t('nav.cooperation')}*/}

                        {/*<a href="https://account.growthukraine.com/auth/sign-in" target={'_blank'} className={'text-secondary'}>*/}
                        {/*    <span>{t('nav.enter')}</span>*/}
                        {/*</a>*/}
                    </div>
                </div>
                <nav
                    className={sidebar ? "nav-menu active shadow d-flex flex-column justify-content-between" : "nav-menu"}>

                    <div className="navbar-toggle flex-column pt-5 mb-5">

                        <div className="d-flex justify-content-between align-items-start w-100">
                            <img src="/logo.png" width={25} alt="logo"/>
                            <h5 className={'text-white display-5'}>
                                Blvd
                            </h5>
                            <Link to="#">
                                <AiIcons.AiOutlineClose className={'text-secondary'} onClick={showSidebar}/>
                            </Link>
                        </div>
                    </div>

                    <ul className="nav-menu-items text-start">


                        <li className={'mb-5'}></li>

                        {SidebarData.map((item, index) => {
                            return (
                                <li key={index} className={item.cName}>
                                    {
                                        <Link to={item.path}>
                                            {/*{item.icon}*/}
                                            <span>{t('nav.' + item.title.toLowerCase())}</span>
                                        </Link>
                                    }
                                </li>
                            );
                        })}
                    </ul>

                    <div className="nav-text1 d-flex justify-content-start align-items-center">
                        <div className="link p-1 m-0">
                            <Link to={BASIC_INFORMATION.socialLinkedIn}>
                                <FaLinkedin size={25}/> <small>LinkedIn</small>
                            </Link>
                        </div>
                        <div className="link p-1 m-0">
                            <Link to={BASIC_INFORMATION.socialInstagram}>
                                <FaInstagram size={25}/> <small>Instagram</small>
                            </Link>
                        </div>
                    </div>

                    <div>
                        <small className={'text-secondary'}>© {(new Date().getFullYear())} Blvd. </small>
                    </div>

                </nav>
            </IconContext.Provider>
        </>
    );
}
